import { useMount } from 'ahooks'
import { Dialog } from '@bcz/nib'
import { isApp, canIUse, exit } from '@bcz/fe-interface'

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 */
export function UpgradeGuard({ children }) {
  const showUpgradeTips = Boolean(isApp && !canIUse('openInWebView'))

  useMount(() => {
    if (showUpgradeTips) {
      Dialog.alert({
        title: '升级提示',
        content: '客户端版本过低，请先升级到最新版本',
        onClose: exit,
      })
    }
  })

  if (showUpgradeTips) {
    return null
  }

  return <>{children}</>
}
